export enum SsoPages {
  SERVICE_HUB = 'SERVICE_HUB',
  COMMUNITY = 'COMMUNITY',
  PLUSME_SUPPORT = 'PLUSME_SUPPORT',
  EDENRED_SUPPORT = 'EDENRED_SUPPORT',
  SELL_CONNECT = 'connect',
  ABOUT_AMADEUS = 'aboutamadeus'
}
